var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid grid-cols-2"},[_c('symbol-progress-component',{attrs:{"symbol":_vm.symbols.symbol_1,"volumeIsUndefined":_vm.volumeIsUndefined}}),_c('symbol-progress-component',{attrs:{"symbol":_vm.symbols.symbol_2,"volumeIsUndefined":_vm.volumeIsUndefined}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }